




















































































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

@Component
export default class ScrollDown extends Vue {

	data() {
		return {
			PageTitle: "Scrolldown animation"
		}
	}
	mounted() {

		new Reveal.revealOnScrollModule()
	}
}
